/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function CapturarFirma({ titulo: e, onGuardar: t, disabled: n = !1 }) {
  let r = (0, React.useRef)(null),
    i = (0, React.useRef)(null),
    a = (0, React.useRef)(0),
    [o, s] = (0, React.useState)(!1),
    [c, l] = (0, React.useState)(!1);
  function u(e) {
    let t = r.current.getBoundingClientRect();
    return [
      ((e.clientX - t.left) * 900) / t.width,
      ((e.clientY - t.top) * 300) / t.height,
    ];
  }
  function f(e) {
    if (n || c || (e.pointerType === `mouse` && e.button !== 0)) return;
    (e.preventDefault(), e.currentTarget.setPointerCapture(e.pointerId));
    let t = r.current.getContext(`2d`);
    (!o &&
      a.current === 0 &&
      ((t.fillStyle = getComputedStyle(document.documentElement)
        .getPropertyValue(`--bg`)
        .trim()),
      t.fillRect(0, 0, 900, 300)),
      (t.strokeStyle = getComputedStyle(document.documentElement)
        .getPropertyValue(`--text-h`)
        .trim()),
      (t.lineWidth = 4),
      (t.lineCap = `round`),
      (t.lineJoin = `round`),
      (i.current = {
        id: e.pointerId,
        punto: u(e),
      }));
  }
  function p(e) {
    if (!i.current || i.current.id !== e.pointerId || c) return;
    let t = u(e),
      n = i.current.punto,
      o = r.current.getContext(`2d`);
    (o.beginPath(),
      o.moveTo(...n),
      o.lineTo(...t),
      o.stroke(),
      (a.current += Math.hypot(t[0] - n[0], t[1] - n[1])),
      (i.current.punto = t),
      a.current > 12 && s(!0));
  }
  function m() {
    (r.current.getContext(`2d`).clearRect(0, 0, 900, 300),
      (a.current = 0),
      (i.current = null),
      s(!1));
  }
  async function h() {
    l(!0);
    try {
      let e = await new Promise((e) => r.current.toBlob(e, `image/png`));
      if (!e) throw Error(`No se pudo leer la firma. Intenta nuevamente.`);
      await t(
        new File([e], `firma.png`, {
          type: `image/png`,
        }),
      );
    } finally {
      l(!1);
    }
  }
  return (
    <section
      className={`min-w-0 space-y-3`}
      children={[
        <p className={`text-sm font-medium text-(--text-h)`} children={e} />,
        <p
          className={`text-xs text-(--text)`}
          children={`Firma con el dedo dentro del recuadro.`}
        />,
        <canvas
          ref={r}
          width={900}
          height={300}
          aria-label={`Firma de ${e}`}
          className={`w-full scroll-my-28 touch-none rounded-2xl border border-(--border) bg-(--bg)`}
          onPointerDown={f}
          onPointerMove={p}
          onPointerUp={() => {
            i.current = null;
          }}
          onPointerCancel={() => {
            i.current = null;
          }}
        />,
        <div
          className={`flex flex-wrap gap-2`}
          children={[
            <AccionAsync
              variante={`secundario`}
              className={`min-h-11`}
              disabled={n || c}
              onClick={m}
              children={`Limpiar firma`}
            />,
            <AccionAsync
              className={`min-h-11`}
              disabled={n || !o}
              onClick={h}
              textoOcupado={`Guardando firma…`}
              children={`Guardar firma`}
            />,
          ]}
        />,
      ]}
    />
  );
}
